import type { DialogStore } from '@ariakit/react'
import { ButtonBrandLegacy } from '@/components/ui/button-brand-legacy'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import {
	Dialog,
	DialogBody,
	DialogDismiss,
	DialogFooter,
	DialogHeader,
	DialogProvider
} from '@/components/ui/dialog-atoms'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from '@/translations/i18n'

interface ProPhotosConfirmSubmitModalProps {
	store: DialogStore
	onSubmit: () => void
	isPending: boolean
}

export const ProPhotosConfirmSubmitModal = ({
	store,
	onSubmit,
	isPending
}: ProPhotosConfirmSubmitModalProps) => {
	const { t } = useTranslation()

	return (
		<DialogProvider store={store}>
			<Dialog hideOnInteractOutside={!isPending} width={'480px'}>
				<DialogHeader className='border-b-0'>
					<DialogDismiss disabled={isPending} />
				</DialogHeader>
				<DialogBody className='gap-1'>
					<h3 className='font-medium text-neutral-900 text-xl'>
						{t('vetting:reordering.submit_photo_modal.title')}
					</h3>
					<p className='text-neutral-900 text-sm'>
						{t('vetting:reordering.submit_photo_modal.description')}
					</p>
				</DialogBody>
				<DialogFooter>
					<ButtonLegacy
						disabled={isPending}
						onClick={() => store.toggle()}
						type='button'
						variant={'tertiary'}
					>
						{t('common:cancel')}
					</ButtonLegacy>

					<ButtonBrandLegacy disabled={isPending} onClick={onSubmit}>
						{t('vetting:reordering.submit_photo_modal.cta')}
						{isPending && <Spinner size={20} />}
					</ButtonBrandLegacy>
				</DialogFooter>
			</Dialog>
		</DialogProvider>
	)
}
